import api from "../api/axios";

/*
|--------------------------------------------------------------------------
| OBTENER TODAS LAS NOTICIAS
|--------------------------------------------------------------------------
*/

export const getNoticias = async () => {
    const response = await api.get("/getNoticia");

    return response.data;
};


/*
|--------------------------------------------------------------------------
| OBTENER UNA NOTICIA
|--------------------------------------------------------------------------
*/

export const getNoticia = async (id) => {
    const response = await api.get(`/showNoticia/${id}`);

    return response.data;
};


/*
|--------------------------------------------------------------------------
| CREAR NOTICIA
|--------------------------------------------------------------------------
*/

export const crearNoticia = async (formData) => {
    const response = await api.post(
        "/storeNoticia",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| ACTUALIZAR NOTICIA
|--------------------------------------------------------------------------
*/

export const actualizarNoticia = async (
    id,
    formData
) => {

    const response = await api.post(
        `/updateNoticia/${id}`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );

    return response.data;
};


/*
|--------------------------------------------------------------------------
| ELIMINAR NOTICIA
|--------------------------------------------------------------------------
*/

export const eliminarNoticia = async (id) => {

    const response = await api.delete(
        `/eliminar/noticia/${id}`
    );

    return response.data;
};


export const getNoticiasPublicas = async () => {
    const response = await api.get("/get/public/Noticia");

    return response.data;
};



export const obtenerNoticiaPorTitulo = async (titulo) => {

    const response = await api.get(
        `/noticias/${encodeURIComponent(titulo)}`
    );

    return response.data.data;

};